import React from "react"

import { SectionQuery } from '../core'
import LocationsSection from './LocationsSection'
import GallerySection from './GallerySection'
import ExpandingGallerySection from './ExpandingGallerySection'
import JobOpeningsSection from './JobOpeningsSection'
import ValuesSection from './ValuesSection'
import CollectionSection from './CollectionSection'
import PressSection from './PressSection'
import MapSection from './MapSection'
import TeamSection from './TeamSection'
import BannerSection from './BannerSection'
import ImageWithContentSection from './ImageWithContentSection'

import Content from "../content";

import './index.scss';

const Section = ({ typename, id, ...rest }) => {
  const RawSection = ({ data }) => {
    const useContentWrapper = data && data.type !== 'blog-feed'
    return (
      <section styleName='raw-section'>
        <div styleName='inner '>
          <div styleName={useContentWrapper && 'content-wrapper'}>
            <Content
              typename={typename}
              id={id}
            />
          </div>
        </div>
      </section>
    )
  }

  const getSection = (typename) => {
    switch (typename) {
    case 'ContentfulSectionLocations':
      return LocationsSection
    case 'ContentfulSectionGallery':
      return GallerySection
    case 'ContentfulSectionExpandingGallery':
      return ExpandingGallerySection
    case 'ContentfulSectionJobOpenings':
      return JobOpeningsSection
    case 'ContentfulSectionMap':
      return MapSection
    case 'ContentfulSectionValues':
      return ValuesSection
    case 'ContentfulSectionContentCollection':
      return CollectionSection
    case 'ContentfulSectionPress':
      return PressSection
    case 'ContentfulSectionTeam':
      return TeamSection
    case 'ContentfulSectionBanner':
      return BannerSection
    case 'ContentfulSectionImageWithContent':
      return ImageWithContentSection
  
    default: 
      return RawSection
    }
  }
  return (
    <SectionQuery
      id={id}
      render={getSection(typename)}
      {...rest}
    />
  )
}

export default Section